// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMMON_PLACES_ABROAD = "Zahrani\u010d\u00ed";
export const PAGE_SLUG = "strana";
